import rolesToFilter from './rolesToFilter';
import statusesToFilter from './statusesToFilter';

export default [
    {
        id: 0,
        value: {
            description: 'id_user_status',
            type: 'select',
            id: 1,
            data: statusesToFilter,
            isIndexed: true,
            operator: 'equal',
            label: 'status'
        },
        label: 'Por estado'
    },
    {
        id: 1,
        value: {
            description: 'role',
            type: 'select',
            id: 1,
            data: rolesToFilter,
            isIndexed: true,
            operator: 'like',
            label: 'role'
        },
        label: 'Por rol'
    },
];
